module.exports = __webpack_public_path__ + "img/00051.b1578ce2.webp";